<template>
    <li class="inline-flex w-full justify-between pt-2 pb-2" :class="{'border-b-2': !withoutBorder}">
        <span class="text-left" :class="!bigMiddle ? 'w-1/2' : 'w-1/4'">
            <slot name="text"></slot>
        </span>
        <span v-if="withValue" class=" text-center" :class="{'w-1/2' : bigMiddle, 'w-1/4': !bigMiddle, 'w-3/4' : noEnd }">
            <slot name="value"></slot>
        </span>
        <span v-if="withIcon" class="text-center" :class="noEnd ? 'hidden' : 'w-1/4'">
            <slot name="icon"></slot>
        </span>
    </li>
</template>

<script>
export default {
  name: 'ListItem',
  props: {
    withValue: Boolean,
    withIcon: Boolean,
    withoutBorder: Boolean,
    bigMiddle: Boolean,
    noEnd: Boolean
  }
}
</script>

<style scoped>
    li {
        list-style: none;
    }
</style>
